<app-breadcrumb  *ngIf="!mod" [master]="'ASF360'" [parentName]="'Grupy uprawnień'" [name]="'Dodaj'"></app-breadcrumb>
<div class="tags-add-container" fxLayout="column" fxLayoutGap="15px"  >
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" *ngIf="!mod">
    <button (click)="sendForm()" mat-stroked-button color="primary" [disabled]="!tagsFormValid">
      <mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxLayout="column" fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
        <mat-card>
          <div fxLayout="row" *ngIf="!mod">
            <h3>Dodawanie Grupy uprawnień</h3>
          </div>

          <div fxLayout="row" *ngIf="mod">
            <h3>Edycja Grupy uprawnień</h3>
          </div>

          <div fxLayout="row" fxLayoutGap="15px">

            <div fxFlex="100">
              <mat-form-field fxFlex="100">
                <mat-label>Nazwa Grupy uprawnień</mat-label>

                <input [formControl]="nameControl" appCapitalizeFirst matInput placeholder="Nazwa Grupy uprawnień"  [required]="true" >

              </mat-form-field>
            </div>
          </div>

<!--          <div fxLayout="row" fxLayoutGap="15px" *ngIf="mod">-->

<!--            <div fxFlex="100">-->

<!--              <mat-slide-toggle fxFlex="100" color="accent" [formControl]="activeControl">Aktywny</mat-slide-toggle>-->

<!--            </div>-->

<!--          </div>-->

        </mat-card>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="sendForm()" mat-stroked-button color="primary" [disabled]="!tagsFormValid">
      <mat-icon>save</mat-icon> <span> Zapisz </span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
